export const PATH_MAIN = "/";
export const PATH_LOGIN = "/login";
export const PATH_CASES = "/cases";
export const PATH_MESSAGES = "/messages";
export const PATH_MESSAGE_DETAIL = "/message/:id";
export const PATH_CASE_DETAIL = "/case/:id/:tab?";
export const PATH_USERS = "/users";
export const PATH_REPORTS = "/reports";
export const PATH_CATEGORIES = "/categories";
export const PATH_TAGS = "/tags";
export const PATH_MAIL_LIST = "/mailList";
export const PATH_NOTIFICATIONS = "/notifications";
export const PATH_PROFILE = "/profile/:id";
export const PATH_TOOLS = "/tools";
export const PATH_SETTINGS = "/settings";
export const PAGE_ADD_LINK = "/addLink";
export const PATH_STARRED = "/starred";



// WEBPACK FOOTER //
// ./src/routes.ts